<template>
  <div class="plk_connections row">
    <div class="menu_components two columns">
      <Menu/>
    </div>
    <div class="connections ten columns columns-center">
      <codemirror v-model="code" :options="cmOptions" />
      <span v-if="errorCode" class="error">{{errorCode}}</span>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import i18n from './i18n'
import Menu from './components/Menu/Index'
import { codemirror } from 'vue-codemirror'
import 'codemirror/lib/codemirror.js'
import 'codemirror/mode/javascript/javascript.js'
import 'codemirror/lib/codemirror.css'
import 'codemirror/theme/elegant.css'
import { DESIGN } from '@/store'

export default {
  name: 'connections',
  components: {
    Menu,
    codemirror
  },
  data () {
    return {
      errorCode: '',
      cmOptions: {
        tabSize: 2,
        autoCloseTags: true,
        mode: 'text/javascript',
        theme: 'elegant',
        lineNumbers: true,
        styleActiveLine: true,
        line: true,
        matchBrackets: true
      }
    }
  },
  computed: {
    code: {
      get: function () {
        return JSON.stringify(this.$store.getters[DESIGN.GETTERS.GET_CONNECTIONS]() || [], null, 2)
      },
      set: function (code) {
        try {
          this.$store.commit({
            type: DESIGN.MUTATIONS.SET_CONNECTIONS,
            connections: JSON.parse(code)
          })
          Vue.set(this, 'errorCode', '')
        } catch (ex) {
          Vue.set(this, 'errorCode', this.$t('designer.connections.malformedObject'))
        }
      }
    }
  },
  methods: {
    onInitComponent () {
      this.$servicesPLK.translation.init(i18n, { overwrite: false })
    }
  }
}
</script>
<style lang="scss">
.plk_connections .CodeMirror {
  border: 1px solid #dee2e6;
  height: 90vh;
}
</style>
<style scoped lang="scss">
.plk_connections {
  background: #f8f9fa;
}
.connections {
  margin-top: 3vh;
  margin-left: 2%;
  margin-right: 2%;
}
.error {
  color: #bb1414;
  text-align: right;
  display: block;
  font-size: small;
  font-weight: bold;
}
.menu_components {
  padding: 5px;
  background: #848e98;;
  height: 100vh;
  overflow: scroll;
  border-right: solid 1px #dee2e6;
}
@media (max-width: 550px) {
  .plk_connections {
    display: flex;
    flex-flow: column;
  }
}
@media (min-width: 550px) {
  .connections.ten.columns {
    width: 82.6666666667%;
  }
}
</style>
